/*
 * @Author: Ryan
 * @Date: 2026-01-09
 * @Description: Why Choose FalcoCut Section for Video Translator landing page
 */
import React from 'react';

import StartButton from '@/3.0/ai-avatar-generator/seo/StartButton';
import { VIDEO_TRANSLATOR_URL } from '@/landing/video-translator/config';

import styles from './index.module.scss';

export interface ReasonItem {
  title: string;
  description: string;
}

export interface WhyChooseSectionProps {
  /** 区块标题 */
  title: string;
  /** 区块副标题 */
  subtitle: string;
  /** 理由列表 */
  reasons: ReasonItem[];
  /** CTA 按钮文本 */
  ctaText: string;
  /** 跳转链接，默认 VIDEO_TRANSLATOR_URL */
  ctaUrl?: string;
}

// 图标列表（按顺序对应设计稿）
const ICONS = ['⚡', '🌐', '🧩', '🔒', '✨', '💰'];

interface ReasonCardProps {
  icon: string;
  title: string;
  description: string;
}

const ReasonCard: React.FC<ReasonCardProps> = ({ icon, title, description }) => {
  return (
    <div className={styles.card}>
      <div className={styles.icon}>{icon}</div>
      <h3 className={styles.cardTitle}>{title}</h3>
      <p className={styles.cardDescription}>{description}</p>
    </div>
  );
};

const WhyChooseSection: React.FC<WhyChooseSectionProps> = ({
  title,
  subtitle,
  reasons,
  ctaText,
  ctaUrl,
}) => {
  const targetUrl = ctaUrl || VIDEO_TRANSLATOR_URL;

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* 标题 */}
        <h2 className={styles.title}>{title}</h2>

        {/* 副标题 */}
        <p className={styles.subtitle}>{subtitle}</p>

        {/* 卡片网格 */}
        <div className={styles.grid}>
          {reasons.map((reason, index) => (
            <ReasonCard
              key={index}
              icon={ICONS[index % ICONS.length]}
              title={reason.title}
              description={reason.description}
            />
          ))}
        </div>

        {/* CTA 按钮 */}
        <div className={styles.ctaWrapper}>
          <StartButton text={ctaText} href={targetUrl} className={styles.ctaButton} />
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
